import { render } from "./index.vue?vue&type=template&id=e56cfeb4"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "D:\\Projects\\Coding\\fzznx\\faie-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__